import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AppShell from './AppShell';
import { socket } from '../socket';

const Wrap = styled.div`
  padding: 16px;
`;

const InputForm = styled.form`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const Input = styled.input`
  flex-grow: 1;
  padding: 12px;
  border-radius: var(--tg-radius-sm);
  border: 1px solid var(--tg-border);
  background: var(--tg-surface);
  color: var(--tg-text);
`;

const CreateButton = styled.button`
  padding: 12px 18px;
  border-radius: var(--tg-radius-sm);
  border: none;
  background: var(--tg-primary);
  color: #fff;
  cursor: pointer;
`;

const RoomsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RoomLink = styled(Link)`
  padding: 16px;
  background: var(--tg-surface);
  border: 1px solid var(--tg-border);
  border-radius: var(--tg-radius);
  text-decoration: none;
  color: var(--tg-text);
  font-weight: 600;
`;

const Rooms = () => {
  const [rooms, setRooms] = useState({});
  const [newRoomName, setNewRoomName] = useState('');

  useEffect(() => {
    socket.on('update-rooms-list', (roomsData) => {
      setRooms(roomsData);
    });

    // Request initial room list when component mounts
    // Note: We need to implement this on the server
    // For now, it will only update when a new room is created.

    return () => {
      socket.off('update-rooms-list');
    };
  }, []);

  const handleCreateRoom = (e) => {
    e.preventDefault();
    if (newRoomName.trim()) {
      socket.emit('create-room', { roomName: newRoomName });
      setNewRoomName('');
    }
  };

  return (
    <AppShell title="Chat Rooms">
      <Wrap>
        <InputForm onSubmit={handleCreateRoom}>
          <Input
            type="text"
            value={newRoomName}
            onChange={(e) => setNewRoomName(e.target.value)}
            placeholder="Enter new room name..."
          />
          <CreateButton type="submit">Create Room</CreateButton>
        </InputForm>
        <RoomsList>
          {Object.entries(rooms).map(([roomId, roomData]) => (
            <RoomLink key={roomId} to={`/room/${roomId}`}>
              {roomData.name}
            </RoomLink>
          ))}
        </RoomsList>
      </Wrap>
    </AppShell>
  );
};

export default Rooms;
